export default function md (str) {
	str = str
		.replace(/\*\*(.*)\*\*/g, '<strong>$1</strong>')
		.replace(/\[(.*)]\((.*)\)/g, '<a href="$2">$1</a>');

	return <span dangerouslySetInnerHTML={{__html:str}} />;
}
